var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrecipitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9444 38.6389C21.9444 43.6248 18.0642 47.6667 13.2777 47.6667C8.49127 47.6667 4.61107 43.6248 4.61107 38.6389C4.61107 35.5193 8.00392 31.3556 10.5439 28.6756C12.0476 27.0891 14.5079 27.0891 16.0116 28.6756C18.5516 31.3556 21.9444 35.5193 21.9444 38.6389Z",
    stroke: "white",
    strokeWidth: 3.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9444 38.6389C47.9444 43.6248 44.0642 47.6667 39.2777 47.6667C34.4913 47.6667 30.6111 43.6248 30.6111 38.6389C30.6111 35.5193 34.0039 31.3556 36.5439 28.6756C38.0476 27.0891 40.5079 27.0891 42.0116 28.6756C44.5516 31.3556 47.9444 35.5193 47.9444 38.6389Z",
    stroke: "white",
    strokeWidth: 3.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9444 16.9723C34.9444 21.9582 31.0642 26 26.2777 26C21.4913 26 17.6111 21.9582 17.6111 16.9723C17.6111 13.8526 21.0039 9.68892 23.5439 7.00893C25.0476 5.4224 27.5079 5.4224 29.0116 7.00893C31.5516 9.68892 34.9444 13.8526 34.9444 16.9723Z",
    stroke: "white",
    strokeWidth: 3.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipitation);
export default __webpack_public_path__ + "static/media/precipitation.ef808dc75954c771c6c95bf56e649915.svg";
export { ForwardRef as ReactComponent };